import { coreApi as api } from "../core/BaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiDashboardWidgets: build.query<
      GetApiDashboardWidgetsApiResponse,
      GetApiDashboardWidgetsApiArg
    >({
      query: () => ({ url: `/api/Dashboard/widgets` }),
    }),
    getApiWidgetsWaitingJobs: build.query<
      GetApiWidgetsWaitingJobsApiResponse,
      GetApiWidgetsWaitingJobsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Widgets/waiting-jobs`,
        params: { userId: queryArg.userId },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiDashboardWidgetsApiResponse = unknown;
export type GetApiDashboardWidgetsApiArg = void;
export type GetApiWidgetsWaitingJobsApiResponse = unknown;
export type GetApiWidgetsWaitingJobsApiArg = {
  userId?: string;
};
export const {
  useGetApiDashboardWidgetsQuery,
  useLazyGetApiDashboardWidgetsQuery,
  useGetApiWidgetsWaitingJobsQuery,
  useLazyGetApiWidgetsWaitingJobsQuery,
} = injectedRtkApi;
